  @if (renownedBranding()) {
    <a class="inline-flex items-center" [href]="renownedUrl | async" rel="noopener noreferrer">
      <img class="md:hidden" [src]="'/logos/renowned-logo-primary.svg' | staticImageUrl" alt="Renowned" width="188" height="36" />
      <img class="hidden md:block xl:hidden" [src]="'/logos/renowned-logo-primary.svg' | staticImageUrl" alt="Renowned" width="120" height="36" />
      <img class="hidden xl:block" [src]="'/logos/renowned-logo-primary.svg' | staticImageUrl" alt="Renowned" width="120" height="36" />
    </a>
  } @else { 
    <a class="inline-flex items-center" routerLink="/">
      @if (loginHeader()) {
        <img class="md:hidden" [src]="'/logos/rma-logo-blue.svg' | staticImageUrl" alt="RateMyAgent" width="188" height="36" />
        <img class="hidden md:block xl:hidden" [src]="'/logos/rma-logo-blue.svg' | staticImageUrl" alt="RateMyAgent" width="120" height="36" />
        <img class="hidden xl:block" [src]="'/logos/rma-logo-blue.svg' | staticImageUrl" alt="RateMyAgent" width="120" height="36" />
      }
      @else {
        <img class="md:hidden" [src]="'/logos/logo-compact-dark.svg' | staticImageUrl" alt="RateMyAgent" width="32" height="36" />
        <img class="hidden md:block xl:hidden" [src]="'/logos/logo-stacked.svg' | staticImageUrl" alt="RateMyAgent" width="64" height="36" />
        <img class="hidden xl:block" [src]="'/logos/logo-dark.svg' | staticImageUrl" alt="RateMyAgent" width="120" height="36" />
    }
    </a>
  }
